module.exports = "<button type=\"button\" class=\"btn\" (click)=\"mprint()\">Print</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/printinner.component.html
// module id = ./src/app/printinner.component.html
// module chunks = main